<div class="p-4 max-w-screen-xl mx-auto">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-semibold">User Instruction LLM</h2>
    </div>
  
    <!-- User ID Input + Button -->
    <div class="flex items-center gap-4 mb-4">
      <input
        type="text"
        [(ngModel)]="userId"
        placeholder="Enter User ID"
        class="flex-1 p-2 border rounded shadow-sm"
      />
      <button class="bg-green-700 text-white px-4 py-2 rounded hover:bg-green-800" (click)="getInstructions()">
        Get Instructions
      </button>
    </div>
  
    <!-- Instructions Display -->
    <div *ngIf="userInstructions" class="mt-6">
        <h3 class="text-lg font-semibold mb-2">Fetched Instructions:</h3>
    
        <div class="text-green-200 text-sm rounded p-4 h-[500px] overflow-auto font-mono">
          <pre class="whitespace-pre-wrap">{{ userInstructions | json }}</pre>
        </div>
    </div>
</div>
  